$(document).ready(function() {
	var ajaxPath = '/includes/varebestilling/ajax.php';
	const ajaxPathGetProductsModal = '/action/product-order/get-product-order-modal';
	const ajaxPathSaveProductOrder = '/action/product-order/save-product-order';
	const ajaxPathTempSaveProduct = '/action/product-order/temp-save-product';
	const ajaxPathGetSearchResult = '/action/product-order/get-search-result';
	const ajaxPathGetSendMailModal = '/action/product-order/get-send_mail_modal';
	const ajaxPathSendProductOrderMail = '/action/product-order/send-product-order-mail';
	let ajaxLocked = false;
	let modalParentElementInDOM = $('div#content');
	let modalTitle = '';
	let modalMessage = '';
	let modalButtonText = 'Lukk';
	let modalAlertType = '';

	var $_GET = {};
	window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(a,name,value){$_GET[name]=value;});
	/*
    if(document.location.toString().indexOf('?') !== -1) {
        var query = document.location
            .toString()
            // get the query string
            .replace(/^.*?\?/, '')
            // and remove any existing hash string (thanks, @vrijdenker)
            .replace(/#.*$/, '')
            .split('&');

        for(var i=0, l=query.length; i<l; i++) {
            var aux = decodeURIComponent(query[i]).split('=');
            $_GET[aux[0]] = aux[1];
        }
    }*/


	$(document).on('click', 'button#save_product_order', function () {
		let supplierId = $('select[name ="product_order_supplier_select"]').children("option:selected").val();

		$('div#product_order_modal_wrapper').remove();

		$.ajax({
			type: 'GET',
			url: ajaxPathGetProductsModal,
			data: {
				supplier_id: supplierId,
			},
			dataType: 'json'
		}).success(function (data) {
			$('div#product_order_form_wrapper').append('<div id="product_order_modal_wrapper"></div>');
			$('div#product_order_modal_wrapper').append(data.html);
			$("div#new_order_modal").modal('toggle');

		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		});
	});

	//Save stock management form, serialize and post
	$(document).on('click', 'div#new_order_modal button#save_product_order_modal', function () {
		if (ajaxLocked) {
			return;
		}
		let supplierId = $('select[name ="product_order_supplier_select"]').children("option:selected").val();
		let orderReference = $('div#modal_order_reference_wrapper input#order_reference_number').val();
		let companyName = $('div#modal_company_info_wrapper input#company_name').val();
		let contactPersonName = $('div#modal_company_info_wrapper input#company_contact_person').val();
		let contactPersonPhone = $('div#modal_company_info_wrapper input#company_contact_phone').val();
		let contactPersonEmail = $('div#modal_company_info_wrapper input#company_contact_email').val();

		//Check that all inputs are numeric
		let isNumeric = true;
		$("form#product_order_form :input").each(function(){
			var val = $(this).val().replace(",", ".");
			console.log(val);
			if (val === ""){
				val = 0;
			}
			if (isNaN(val)){
				isNumeric = false;
			}
		});

		if (isNumeric) {
			ajaxLocked = true;
			$.ajax({
				type: 'POST',
				url: ajaxPathSaveProductOrder,
				data: {
					supplier_id: supplierId,
					order_reference: orderReference,
					ordering_company_name: companyName,
					contact_person_name: contactPersonName,
					contact_person_phone: contactPersonPhone,
					contact_person_email: contactPersonEmail,
				},
				dataType: 'json'
			}).success(function (data) {
				location.reload();
				let message = data.html;
				$('<div class="alert alert-danger">' + message + '</div>').insertBefore($('fieldset#fieldset_product_order_filter_wrapper'));

			}).error(function (data) {
				$('div#new_order_modal .alert-danger').remove();
				let errorMessage = $.parseJSON(data.responseText).errors;
				$('<div class="alert alert-danger">' + errorMessage + '</div>').insertBefore($('div#modal_supplier_wrapper'));
			}).always(function (data) {
				ajaxLocked = false;
			});
		} else {
			alert('Ikke numeriske verdier');
		}
	});
	//If ENTER is clicked when searching for products, refresh form
	$('div#product_order_form_wrapper input#products-search').keyup(function(e) {
		let key = e.which;
		let searchInput = $('div#product_order_list_wrapper input#products-search');

		// Refresh list if enter was pressed
		if (key === 13 || searchInput.val() === '') {
			let url = updateURLParameter(window.location.href, "q", $("input#products-search").val());
			url = updateURLParameter(url, "page", 1);
			window.history.replaceState('', '', url);
			window.location.href = url;
		}
	});

	//If the product search button is clicked, refresh form
	$(document).on('click', 'div#product_order_form_wrapper button#products-search-btn', function () {
		let url = updateURLParameter(window.location.href, "q", $("input#products-search").val());
		url = updateURLParameter(url, "page", 1);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//If the supplier select changes, refresh form
	$(document).on('change', "select[name='product_order_supplier_select']", function(){
		let tempSavedProductsFilter = $("select[name='temp_saved_products_filter']").val();
		let url = updateURLParameter(window.location.href, "supplier_id", $("select[name='product_order_supplier_select']").val());
		url = updateURLParameter(url, "page", 1);
		url = updateURLParameter(url, "show_temp_products", tempSavedProductsFilter);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//If the temp-saved-products-filter changes, refresh form
	$(document).on('change', "div#product_order_form_wrapper select[name='temp_saved_products_filter']", function(){
		let supplierFilter = $("select[name='product_order_supplier_select']").val();
		let url = updateURLParameter(window.location.href, "show_temp_products", $("select[name='temp_saved_products_filter']").val());
		url = updateURLParameter(url, "page", 1);
		url = updateURLParameter(url, "supplier_id", supplierFilter);
		window.history.replaceState('', '', url);
		window.location.href = url;
	});

	//Send order by mail, open modal
	$(document).on('click', 'div#item_list_wrapper a.send_order_by_mail', function () {
		$('div#send_mail_modal_wrapper').remove();
		$('.modal').modal('hide');
		let productOrderId = $(this).parents('.list-item-product-order').first().attr("product_order_id");
		let isBackOrder = 0;

		$.ajax({
			type: 'GET',
			url: ajaxPathGetSendMailModal,
			data: {
				order_id: productOrderId,
				is_back_order: isBackOrder,
			},
			dataType: 'json'
		}).success(function (data) {
			$('div#product_order_form_wrapper').append('<div id="send_mail_modal_wrapper"></div>');
			$('div#send_mail_modal_wrapper').append(data.html);
			$("div#send_email_modal").modal('toggle');

		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		});
	});

	//Temp save amount on varebestilling
	$(document).on('change', 'input.product_amount', function () {
		let supplierId = $('select[name ="product_order_supplier_select"]').children("option:selected").val();
		let amount = $(this).val();
		let productId = $(this).attr("data-id");

		$.ajax({
			type: 'POST',
			url: ajaxPathTempSaveProduct,
			data: {
				supplier_id: supplierId,
				amount: amount,
				product_id: productId
			},
			dataType: 'json'
		}).success(function (data) {
			if (data.status !== 'OK') {
				let trRow = $('input[name="amount_' + productId + '"]').parent().parent();
				trRow.addClass('success');
				trRow.notify(data.status, {position:"left", className: "success"});

				const queryString = window.location.search;
				let urlParams = new URLSearchParams(queryString);
				let hideTrRow = urlParams.get('show_temp_products') === '0';
				if (hideTrRow) {
					trRow.hide(5500);
				}
			}


		}).error(function (data) {
			let row = $('input[name="amount_' + productId + '"]').parent().parent();
			let errorMessage = $.parseJSON(data.responseText).errors;
			row.removeClass('success');
			row.notify(errorMessage, {position:"left", className: "error"});
		});
	});

	//Send order by mail
	$(document).on('click', 'div#product_order_form_wrapper button#send_order_mail', function () {
		if (ajaxLocked) {
			return;
		}
		let supplierEmailAddress = $('div#send_email_modal input#supplier_email_modal').val();
		let copyEmailAddress = $('div#send_email_modal input#copy_email_modal').val();
		let productOrderId = $('div#send_email_modal input#order_id').val();
		let isBackOrder = 0;

		ajaxLocked = true;
		$.ajax({
			type: 'POST',
			url: ajaxPathSendProductOrderMail,
			data: {
				supplier_email_address: supplierEmailAddress,
				copy_email_address: copyEmailAddress,
				order_id: productOrderId,
				is_back_order: isBackOrder
			},
			dataType: 'json'
		}).success(function (data) {
			$('div#send_mail_modal_wrapper').remove();
			let element = $('div#left_side_form');
			if (copyEmailAddress === '') {
				displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.', 'success', element);
			} else {
				displayAlertMessage('E-post sendt!', 'Bestilling sendt til: ' + supplierEmailAddress + '.<br/> Kopi sendt til: ' + copyEmailAddress + '.', 'success', element);
			}

		}).error(function (data) {
			let element = $('div#send_email_modal_content');
			let errorMessage = $.parseJSON(data.responseText).errors;

			displayAlertMessage('Det oppstod en feil!', errorMessage, 'danger', element);
		}).always(function () {
			ajaxLocked = false;
		});
	});

	//Get search result for Product Order when button is clicked
	$(document).on('click', 'div#product_order_list_wrapper button#product_order_search_button', function () {
		if ($('div#product_order_list_wrapper input#product_order_search_input').val() !== '') {
			getSearchResult();
		}
	});

	//Get search result for Product Order when ENTER is pressed or input is removed
	$('div#product_order_list_wrapper input#product_order_search_input').keyup(function(e) {
		let key = e.which;
		let searchInput = $('div#product_order_list_wrapper input#product_order_search_input');

		// Refresh list if enter was pressed or the search field is empty
		if (key === 13 || searchInput.val() === '') {
			getSearchResult();
		}
	});

	/**
	 * Functions
	 */

	function updateURLParameter(url, param, paramVal){
		var newAdditionalURL = "";
		var tempArray = url.split("?");
		var baseURL = tempArray[0];
		var additionalURL = tempArray[1];
		var temp = "";
		if (additionalURL) {
			tempArray = additionalURL.split("&");
			for (var i=0; i<tempArray.length; i++){
				if(tempArray[i].split('=')[0] != param){
					newAdditionalURL += temp + tempArray[i];
					temp = "&";
				}
			}
		}

		var rows_txt = temp + "" + param + "=" + paramVal;
		return baseURL + "?" + newAdditionalURL + rows_txt;
	}

	/**
	 * Check input from user and get result from search
	 */
	function getSearchResult() {
		if (ajaxLocked) {
			return;
		}
		let searchString = $('div#product_order_list_wrapper input#product_order_search_input').val();

		ajaxLocked = true;
		$.ajax({
			type: 'GET',
			url: ajaxPathGetSearchResult,
			data: {
				search_string: searchString,
			},
			dataType: 'json'
		}).success(function (data) {
			$('div#product_order_list_wrapper div#item_list_wrapper').replaceWith(data.html);

		}).error(function (data) {
			modalTitle = 'Det oppstod en feil!';
			modalMessage = $.parseJSON(data.responseText).errors;
			modalAlertType = 'error';

			displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, modalButtonText, modalAlertType);
		}).always(function (data) {
			ajaxLocked = false;
		});
	}
});